<script setup>
import {onMounted, ref, defineProps, computed, nextTick, watch} from 'vue'

const props = defineProps({
  title: {
    type: String,
    default: "Headline"
  }, 

  divider: {
    type: Boolean,
    default: false,
  }
});
  
</script>

<template>
  <div>
    <h2 class="jura">{{ props.title }}</h2> 
    <hr v-if="props.divider">
  </div>
</template>

<style scoped>
  
</style>
